export const SITE_URL = "https://yootelco.com";
export const SITE_LOGO = `${SITE_URL}/favicon.ico`;

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Yootelco",
  url: SITE_URL,
  logo: SITE_LOGO,
  description:
    "Global telecom solutions provider offering OTP verification, A2P SMS, wholesale voice, SIP trunking, and international messaging.",
  areaServed: "Worldwide",
  knowsAbout: [
    "Telecommunications",
    "A2P SMS",
    "OTP Verification",
    "SIP Trunking",
    "Wholesale Voice",
    "CPaaS",
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Yootelco",
  url: SITE_URL,
  publisher: { "@type": "Organization", name: "Yootelco", url: SITE_URL },
};

export type FaqItem = { question: string; answer: string };

export const faqSchema = (faqs: FaqItem[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
});

export type BreadcrumbItem = { name: string; path: string };

export const breadcrumbSchema = (items: BreadcrumbItem[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

const SEGMENT_LABELS: Record<string, string> = {
  solutions: "Solutions",
  "use-cases": "Use Cases",
  industries: "Industries",
  "coverage-routes": "Coverage & Routes",
  about: "About",
  contact: "Contact",
  events: "Events",
  terms: "Terms of Service",
  "privacy-policy": "Privacy Policy",
};

const titleCase = (segment: string) =>
  segment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

/** Builds a BreadcrumbList from a route path, e.g. /use-cases/promotional-sms */
export const breadcrumbsFromPath = (path: string): BreadcrumbItem[] => {
  const segments = path.split("/").filter(Boolean);
  if (segments.length === 0) return [];
  const items: BreadcrumbItem[] = [{ name: "Home", path: "/" }];
  let acc = "";
  segments.forEach((segment) => {
    acc += `/${segment}`;
    items.push({ name: SEGMENT_LABELS[segment] ?? titleCase(segment), path: acc });
  });
  return items;
};
